/**
 * Plumastro city autocomplete — plumatotm API only (no GeoNames).
 * Loaded via {{ 'city-autocomplete-v2.js' | asset_url | script_tag }}
 */
(function (global) {
  'use strict';

  var CITIES_SEARCH_API_URL = 'https://plumatotm.onrender.com/cities/search';
  var PLACE_MIN_LENGTH = 3;
  var DEFAULT_MAX_ROWS = 30;
  var DEFAULT_DEBOUNCE_MS = 200;
  var DEFAULT_MAX_SUGGESTIONS = 25;

  function placeNormalizeForMatch(str) {
    if (!str) return '';
    var s = String(str)
      .toLowerCase()
      .replace(/-/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    try {
      s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    } catch (e) {}
    return s;
  }

  function formatPlaceDisplay(place) {
    var name = (place.name || place.toponymName || '').trim();
    var country = (place.countryName || place.countryCode || '').trim();
    var admin1 = (place.adminName1 || '').trim();
    var admin2 = (place.adminName2 || '').trim();
    if (!name) return '';
    var region = admin1 || admin2;
    var parts = [name];
    if (region) parts.push(region);
    if (country) parts.push(country);
    return parts.join(', ');
  }

  function placeDisplayKey(place) {
    var n = placeNormalizeForMatch(place.name || place.toponymName || '');
    var cc = (place.countryCode || '').toUpperCase();
    var a1 = placeNormalizeForMatch(place.adminName1 || '');
    return n + '|' + cc + '|' + a1;
  }

  function placeEscapeHtml(str) {
    return (str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function normalizeLang(lang) {
    var code = String(lang || 'fr')
      .split('-')[0]
      .toLowerCase();
    return code === 'en' ? 'en' : 'fr';
  }

  function parseCitiesResponse(data) {
    if (Array.isArray(data)) return data;
    if (data && typeof data === 'object') {
      if (Array.isArray(data.cities)) return data.cities;
      if (Array.isArray(data.results)) return data.results;
      var keys = Object.keys(data);
      for (var i = 0; i < keys.length; i++) {
        if (Array.isArray(data[keys[i]])) return data[keys[i]];
      }
    }
    return [];
  }

  function buildSearchUrl(query, lang, maxRows) {
    var params = new URLSearchParams();
    params.set('q', String(query || '').trim());
    params.set('lang', normalizeLang(lang));
    params.set('maxRows', String(maxRows || DEFAULT_MAX_ROWS));
    return CITIES_SEARCH_API_URL + '?' + params.toString();
  }

  function fetchCities(query, options) {
    var opts = options || {};
    var q = String(query || '').trim();
    if (q.length < PLACE_MIN_LENGTH) return Promise.resolve([]);
    var url = buildSearchUrl(q, opts.lang, opts.maxRows);
    return fetch(url, { signal: opts.signal })
      .then(function (res) {
        if (!res.ok) throw new Error(String(res.status));
        return res.json();
      })
      .then(parseCitiesResponse);
  }

  function debounce(fn, delay) {
    var timer = null;
    return function () {
      var self = this;
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(self, args);
      }, delay);
    };
  }

  function init(options) {
    if (!options || !options.wrap || !options.input || !options.list) return null;

    var wrap = options.wrap;
    var input = options.input;
    var list = options.list;
    var latEl = options.latEl || null;
    var lonEl = options.lonEl || null;
    var countryEl = options.countryEl || null;
    var stateEl = options.stateEl || null;
    var cityEl = options.cityEl || null;
    var lang = normalizeLang(options.lang);
    var maxRows = options.maxRows || DEFAULT_MAX_ROWS;
    var maxSuggestions = options.maxSuggestions || DEFAULT_MAX_SUGGESTIONS;
    var debounceMs = options.debounceMs || DEFAULT_DEBOUNCE_MS;
    var itemClass = options.itemClass || 'place-item';
    var errorMessage =
      options.errorMessage || 'Sélectionne une ville dans la liste.';
    var productForm = options.productForm || null;
    var onChoose = typeof options.onChoose === 'function' ? options.onChoose : null;
    var onInput = typeof options.onInput === 'function' ? options.onInput : null;
    var useFixedPosition = !!options.useFixedPosition;

    if (wrap.dataset.inited === 'true') {
      return {
        hasValidGeo: hasValidGeo,
        markNotSelected: markNotSelected,
        markSelected: markSelected
      };
    }
    wrap.dataset.inited = 'true';
    if (!wrap.dataset.selected) wrap.dataset.selected = 'false';

    var cache = new Map();
    var aborter = null;
    var listHomeParent = list.parentNode;
    var listHomeNext = list.nextSibling;
    var positionListenersBound = false;
    var portalHost = null;

    function markSelected() {
      wrap.dataset.selected = 'true';
      input.setCustomValidity('');
    }

    function markNotSelected() {
      wrap.dataset.selected = 'false';
    }

    function hasValidGeo() {
      if (wrap.dataset.selected !== 'true') return false;
      var latRaw = (latEl && latEl.value) || '';
      var lonRaw = (lonEl && lonEl.value) || '';
      latRaw = String(latRaw).trim();
      lonRaw = String(lonRaw).trim();
      if (!latRaw || !lonRaw) return false;
      var lat = Number(latRaw);
      var lon = Number(lonRaw);
      return Number.isFinite(lat) && Number.isFinite(lon);
    }

    function clearListPositionStyles() {
      list.style.position = '';
      list.style.left = '';
      list.style.top = '';
      list.style.width = '';
      list.style.right = '';
      list.style.zIndex = '';
      list.style.maxHeight = '';
      list.style.pointerEvents = '';
    }

    function restoreListHome() {
      if (!listHomeParent || list.parentNode === listHomeParent) return;
      if (listHomeNext && listHomeNext.parentNode === listHomeParent) {
        listHomeParent.insertBefore(list, listHomeNext);
      } else {
        listHomeParent.appendChild(list);
      }
    }

    function ensurePortalHost() {
      if (portalHost && portalHost.isConnected) return portalHost;
      portalHost = document.createElement('div');
      portalHost.className = 'pluma-city-suggest-portal';
      portalHost.setAttribute('data-pluma-city-suggest-portal', 'true');
      /* Fixed fullscreen layer: absolute children use getBoundingClientRect coords (Safari-safe). */
      portalHost.style.cssText =
        'position:fixed;inset:0;width:auto;height:auto;margin:0;padding:0;border:0;z-index:10050;pointer-events:none;';
      document.body.appendChild(portalHost);
      return portalHost;
    }

    function destroyPortalHost() {
      if (!portalHost) return;
      if (portalHost.parentNode) portalHost.parentNode.removeChild(portalHost);
      portalHost = null;
    }

    function positionFixedList() {
      var host = ensurePortalHost();
      if (list.parentNode !== host) host.appendChild(list);

      var rect = input.getBoundingClientRect();
      var hostRect = host.getBoundingClientRect();
      /* Always below the field — may overlap sticky Continuer (desired). */
      var top = rect.bottom - hostRect.top + 6;
      var left = rect.left - hostRect.left;
      var spaceBelow = hostRect.height - (rect.bottom - hostRect.top) - 8;
      var maxH = Math.min(280, Math.max(120, spaceBelow));

      list.style.position = 'absolute';
      list.style.left = Math.round(left) + 'px';
      list.style.top = Math.round(top) + 'px';
      list.style.width = Math.round(rect.width) + 'px';
      list.style.right = 'auto';
      list.style.zIndex = '1';
      list.style.maxHeight = Math.round(maxH) + 'px';
      list.style.pointerEvents = 'auto';
    }

    function bindPositionListeners() {
      if (positionListenersBound || !useFixedPosition) return;
      positionListenersBound = true;
      window.addEventListener('scroll', positionFixedList, true);
      window.addEventListener('resize', positionFixedList);
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', positionFixedList);
        window.visualViewport.addEventListener('scroll', positionFixedList);
      }
    }

    function unbindPositionListeners() {
      if (!positionListenersBound) return;
      positionListenersBound = false;
      window.removeEventListener('scroll', positionFixedList, true);
      window.removeEventListener('resize', positionFixedList);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', positionFixedList);
        window.visualViewport.removeEventListener('scroll', positionFixedList);
      }
    }

    function closeList() {
      list.style.display = 'none';
      list.innerHTML = '';
      wrap.classList.remove('is-suggest-open');
      if (useFixedPosition) {
        unbindPositionListeners();
        clearListPositionStyles();
        restoreListHome();
        destroyPortalHost();
      }
    }

    function openList() {
      if (!list.children.length) return;
      if (useFixedPosition) {
        positionFixedList();
        bindPositionListeners();
      }
      list.style.display = 'block';
      wrap.classList.add('is-suggest-open');
      if (useFixedPosition) {
        requestAnimationFrame(positionFixedList);
      }
    }

    function choose(place) {
      var name = (place.name || place.toponymName || '').trim();
      var countryName = (place.countryName || '').trim();
      var countryCode = (place.countryCode || '').toUpperCase();
      var adminName1 = (place.adminName1 || '').trim();
      input.value = formatPlaceDisplay(place);
      if (place.lat != null && latEl) latEl.value = String(place.lat);
      if (place.lng != null && lonEl) lonEl.value = String(place.lng);
      if (countryEl) countryEl.value = countryName || countryCode || '';
      if (stateEl) stateEl.value = adminName1 || '';
      if (cityEl) cityEl.value = name || '';
      markSelected();
      closeList();
      if (onChoose) onChoose(place, { name: name, countryName: countryName, adminName1: adminName1 });
    }

    function renderSuggest(places) {
      if (!places || !places.length) {
        closeList();
        return;
      }
      var seen = new Set();
      var unique = [];
      for (var i = 0; i < places.length; i++) {
        var p = places[i];
        var key = placeDisplayKey(p);
        if (!key || key === '||' || seen.has(key)) continue;
        seen.add(key);
        unique.push(p);
      }
      list.innerHTML = '';
      if (!unique.length) {
        closeList();
        return;
      }
      unique.slice(0, maxSuggestions).forEach(function (p) {
        var name = (p.name || p.toponymName || '').trim();
        var region = (p.adminName1 || p.adminName2 || '').trim();
        var country = (p.countryName || p.countryCode || '').trim();
        if (!name) return;
        var rest = [region, country].filter(Boolean).map(placeEscapeHtml).join(', ');
        var item = document.createElement('div');
        item.className = itemClass;
        item.setAttribute('role', 'option');
        item.innerHTML =
          '<strong>' + placeEscapeHtml(name) + '</strong>' + (rest ? ', ' + rest : '');
        item.addEventListener('mousedown', function (ev) {
          ev.preventDefault();
          choose(p);
        });
        list.appendChild(item);
      });
      openList();
    }

    function fetchSuggestions(query) {
      var q = String(query || '').trim();
      if (q.length < PLACE_MIN_LENGTH) {
        closeList();
        return;
      }
      var cacheKey = q + '|' + lang;
      if (cache.has(cacheKey)) {
        renderSuggest(cache.get(cacheKey));
        return;
      }
      if (aborter) aborter.abort();
      aborter = new AbortController();
      fetchCities(q, { lang: lang, maxRows: maxRows, signal: aborter.signal })
        .then(function (places) {
          cache.set(cacheKey, places);
          renderSuggest(places);
        })
        .catch(function (e) {
          if (e.name !== 'AbortError') closeList();
        })
        .finally(function () {
          aborter = null;
        });
    }

    var fetchSuggestionsDebounced = debounce(fetchSuggestions, debounceMs);

    input.addEventListener('input', function (e) {
      markNotSelected();
      input.setCustomValidity('');
      if (latEl) latEl.value = '';
      if (lonEl) lonEl.value = '';
      if (countryEl) countryEl.value = '';
      if (stateEl) stateEl.value = '';
      if (cityEl) cityEl.value = '';
      if (onInput) onInput(e);
      if (String(e.target.value || '').trim().length < PLACE_MIN_LENGTH) closeList();
      fetchSuggestionsDebounced(e.target.value);
    });

    input.addEventListener('focus', function () {
      openList();
    });

    input.addEventListener('blur', function () {
      setTimeout(closeList, 120);
    });

    if (productForm) {
      productForm.addEventListener(
        'submit',
        function (e) {
          if (!hasValidGeo()) {
            e.preventDefault();
            e.stopPropagation();
            input.setCustomValidity(errorMessage);
            input.reportValidity();
            if (input.focus) input.focus();
            return false;
          }
          input.setCustomValidity('');
        },
        true
      );
    }

    return {
      hasValidGeo: hasValidGeo,
      markNotSelected: markNotSelected,
      markSelected: markSelected,
      closeList: closeList
    };
  }

  global.PlumaCityAutocomplete = {
    CITIES_SEARCH_API_URL: CITIES_SEARCH_API_URL,
    PLACE_MIN_LENGTH: PLACE_MIN_LENGTH,
    DEFAULT_MAX_ROWS: DEFAULT_MAX_ROWS,
    buildSearchUrl: buildSearchUrl,
    fetchCities: fetchCities,
    parseCitiesResponse: parseCitiesResponse,
    formatPlaceDisplay: formatPlaceDisplay,
    placeDisplayKey: placeDisplayKey,
    placeNormalizeForMatch: placeNormalizeForMatch,
    init: init
  };
})(typeof window !== 'undefined' ? window : this);
